import React, { useState } from 'react';
import {
    Box,
    Button,
    Typography,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    Backdrop,
    Snackbar,
    Alert,
    CircularProgress,
    Divider,
    InputAdornment,
} from '@mui/material';
import { CloudUpload, Save, VideoLibrary, LocationCity, Movie } from '@mui/icons-material';
import { AdminPage, SectionTitle, GREEN, LIGHT, BORDER, primaryButtonSx } from '../admin/AdminPageLayout';
import { useEffect } from 'react';
import axios from 'axios';
import { district_admin, upload_image_all } from '../api/API';


function MainAddVideoDistrict() {
    const [videoFile, setVideoFile] = useState('');
    const [videoURL, setVideoURL] = useState('');
    const [district, setDistrict] = useState([]); // จังหวัด
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [form, setForm] = useState({
        video: videoURL,  // หมวดที่อยู่
        did: '', // ไอดีจังหวัด

    });
    const [errorSnackbar, setErrorSnackbar] = useState({
        open: false,
        message: "",
    });
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error" | "warning" | "info"


    useEffect(() => {
        const fetchData = async () => {
            if (!token) return;
            setInitialLoading(true);
            setLoading(true);
            try {
                const resDistrict = await axios.get(district_admin, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });

                // console.log("resDistrict", resDistrict.data);
                setDistrict(resDistrict.data);
            } catch (err) {
                console.error("Fetch district error:", err);
                setErrorSnackbar({
                    open: true,
                    message: "โหลดข้อมูลล้มเหลว",
                });
            } finally {
                setLoading(false);
                setInitialLoading(false);
            }
        };

        fetchData();
    }, [token]); // ✅ เพิ่ม token ใน dependency array

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    // const handleVideoUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setVideoFile(file);
    //         setVideoURL(URL.createObjectURL(file));
    //     }
    // };
    const handleVideoUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setVideoFile(file);
            const url = URL.createObjectURL(file);
            setVideoURL(url); // ✅ ตั้งค่าตรงนี้เพื่อให้โชว์ preview
        }
    };
    // const handleVideoUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setVideoFile(file);
    //         setVideoURL(URL.createObjectURL(file));
    //     }
    // };

    const handleChange = (field) => (event) => {
        let value = event.target.value;
        if (field === "did") {
            value = Number(value); // แปลงให้เป็น int
        }
        setForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSubmit = async () => {
        if (!videoFile || form.did === 0) {
            setErrorSnackbar({
                open: true,
                message: "กรุณากรอกข้อมูลให้ครบถ้วน",
            });
            return;
        }
        // console.log("videoFile", videoFile);
        // console.log("form.did", form.did);
        // setLoading(true);

        // try {

        const newDistrctId = 6;
        const formData = new FormData();
        let primaryMediaType = '';

        // 🚨 ขั้นตอนที่ 1: ตรวจสอบและรวบรวมไฟล์จริง (แก้ปัญหาการเข้าถึง/การวนซ้ำ)
        let filesToUpload = [];

        // 💡 Case 1: videoFile เป็น File Object โดยตรง (เช่น จาก input.files[0])
        if (videoFile instanceof File) {
            filesToUpload = [videoFile];
        }
        // 💡 Case 2: videoFile เป็น Array ที่มี File Objects อยู่ข้างใน (กรณี Multi-file)
        else if (Array.isArray(videoFile)) {
            videoFile.forEach(item => {
                // รองรับทั้ง item ที่เป็น File หรือ item ที่มี property .file
                const file = (item instanceof File) ? item : (item && item.file instanceof File) ? item.file : null;
                if (file) {
                    filesToUpload.push(file);
                }
            });
        }

        // ----------------------------------------------------
        // 2. วนลูปเพื่อสร้าง FormData ด้วยไฟล์ที่รวบรวมได้
        // ----------------------------------------------------

        if (filesToUpload.length === 0) {
            setErrorSnackbar({ open: true, message: "ไม่พบไฟล์วิดีโอ/รูปภาพที่รองรับสำหรับการอัปโหลด" });
            return;
        }

        filesToUpload.forEach((file) => {
            const fileName = file.name;
            const extension = fileName.split('.').pop().toLowerCase();
            const isImage = ['jpg', 'jpeg', 'png', 'webp', 'gif'].includes(extension);
            const isVideo = ['mp4', 'mov', 'avi', 'mkv'].includes(extension);

            if (isImage || isVideo) {
                // 🎯 APPEND ไฟล์ภายใต้ Key 'files' เพื่อให้ Backend รับได้
                formData.append("files", file);

                if (primaryMediaType === '') {
                    primaryMediaType = isImage ? 'image' : 'vdo';
                }
            }
        });

        // ----------------------------------------------------
        // 3. กำหนดค่าพารามิเตอร์ Text คงที่ (นอก Loop)
        // ----------------------------------------------------

        if (formData.getAll("files").length === 0 || primaryMediaType === '') {
            setErrorSnackbar({ open: true, message: "ไม่พบไฟล์ที่ถูกต้องหลังจากตรวจสอบประเภทสื่อ" });
            return;
        }

        formData.append("media_type", primaryMediaType);
        formData.append("place_type", "route_vdo");
        formData.append("ref_id", newDistrctId);

        // Debugging Final FormData (ตรวจสอบว่ามี key:files และ key:media_type)
        console.log("--- Final FormData Contents ---");
        for (let [key, value] of formData.entries()) {
            // ถ้าเป็นไฟล์ จะแสดง [object File], ถ้าเป็น text จะแสดงค่า
            // console.log(`Key: ${key}`, value);
        }
        console.log("-------------------------------");

        // ----------------------------------------------------
        // 4. เรียก API
        // ----------------------------------------------------
        const uploadRes = await axios.post(upload_image_all, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("uploadRes", uploadRes);

        // if (uploadRes.status === 201 || uploadRes.status === 207) {
        //     const folderID = uploadRes.data.folderID; // 💡 ดึง Folder ID กลับมาเก็บไว้
        //     // ... (โค้ด Success Snackbar และ Reset state) ...
        // } else {
        //     // ... (โค้ดแสดง Error Snackbar) ...
        // }



        //     if (uploadVDO.status === 200) {
        //         setSnackbarMessage("อัปโหลดวิดีโอสำเร็จ");
        //         setSnackbarSeverity("success");
        //         setSnackbarOpen(true);

        //         // Reset state
        //         setVideoFile('');
        //         setVideoURL('');
        //         setForm({ ...form, did: 0 });
        //     } else {
        //         setSnackbarMessage("❌ ไม่สามารถบันทึกข้อมูลได้");
        //         setSnackbarSeverity("error");
        //         throw new Error("Upload failed");
        //     }
        // } catch (error) {
        //     console.error("Upload error:", error);
        //     setSnackbarMessage("เกิดข้อผิดพลาดในการอัปโหลด");
        //     setSnackbarSeverity("error");
        //     setSnackbarOpen(true);
        // } finally {
        //     setLoading(false);
        // }
    };

    return (
        <>
            {loading && (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                </div>
            )}
            <AdminPage
                icon={<VideoLibrary fontSize="large" />}
                title="อัปโหลดวิดีโอ"
                subtitle="เลือกอำเภอและอัปโหลดวิดีโอประจำพื้นที่"
                maxWidth={720}
                actions={
                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleSubmit}
                        startIcon={<Save />}
                        sx={primaryButtonSx}
                    >
                        อัปโหลด
                    </Button>
                }
            >
                <SectionTitle step={1} title="เลือกอำเภอ" />
                <FormControl fullWidth>
                    <InputLabel id="district-video-label">
                        เลือกอำเภอ
                    </InputLabel>
                    <Select
                        labelId="district-video-label"
                        label="เลือกอำเภอ"
                        value={form.did}
                        onChange={handleChange("did")}
                        startAdornment={
                            <InputAdornment position="start">
                                <LocationCity sx={{ color: GREEN }} />
                            </InputAdornment>
                        }
                    >
                        <MenuItem value={0}>
                            <em>-- เลือกอำเภอ --</em>
                        </MenuItem>
                        {district?.length > 0 &&
                            district.map((d) => (
                                <MenuItem key={d.did} value={Number(d.did)}>
                                    {d.name}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>

                <Divider sx={{ my: 3 }} />

                <SectionTitle step={2} title="ไฟล์วิดีโอ" />
                <Box
                    sx={{
                        border: `2px dashed ${BORDER}`,
                        borderRadius: 3,
                        bgcolor: LIGHT,
                        p: 3,
                        textAlign: "center",
                    }}
                >
                    <CloudUpload sx={{ fontSize: 48, color: GREEN }} />
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        รองรับไฟล์วิดีโอ เช่น .mp4, .mov, .avi, .mkv
                    </Typography>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<CloudUpload />}
                        sx={{ borderRadius: 3, color: GREEN, borderColor: GREEN, bgcolor: "white" }}
                    >
                        เลือกวิดีโอ
                        <input hidden accept="video/*" type="file" onChange={handleVideoUpload} />
                    </Button>
                    {videoFile?.name && (
                        <Typography variant="body2" sx={{ mt: 1.5, color: "#33691e", wordBreak: "break-all" }}>
                            {videoFile.name}
                        </Typography>
                    )}
                </Box>

                {videoURL && (
                    <>
                        <Divider sx={{ my: 3 }} />
                        <SectionTitle step={3} title="ตัวอย่างวิดีโอ" extra={<Movie sx={{ color: GREEN }} />} />
                        <Box sx={{ borderRadius: 3, overflow: "hidden", border: `1px solid ${BORDER}`, bgcolor: "#000" }}>
                            <video width="100%" height="auto" controls style={{ display: "block" }}>
                                <source src={videoURL} type={videoFile?.type || "video/mp4"} />
                                เบราว์เซอร์ของคุณไม่รองรับการแสดงวิดีโอ
                            </video>
                        </Box>
                    </>
                )}
            </AdminPage>
            {/* // JSX ส่วนแสดง error Snackbar */}
            <Snackbar
                open={errorSnackbar.open}
                autoHideDuration={3000}
                onClose={() => setErrorSnackbar({ open: false, message: "" })}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    severity="error"
                    variant="filled"
                    sx={{ fontWeight: "bold" }}
                >
                    {errorSnackbar.message}
                </Alert>
            </Snackbar>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={initialLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default MainAddVideoDistrict